/**
 * Programs Translations Module (Portuguese)
 * @module programs
 * @language pt
 */

export const programs = {
  programsEventsPage: { pageSubtitle: "JCI RISE • CYE • JIB • Debate • Oratória • Conferências 2024-2025" },
  programs: {
    flagshipPrograms: "Programas Principais",
    competitionTopics: "Tópicos da Competição",
    skillDevelopment: "Desenvolvimento de Habilidades",
    skillFocusAreas: "Áreas de Foco de Habilidades",
    competitionFormat: "Formato da Competição",
    programDataMetrics: "Dados de impacto real do Relatório de Impacto JCI 2025",
    coreInitiative: "Iniciativa Principal",
    jciRise: "JCI RISE",
    riseQuote: "Reconstruindo comunidades, Inspirando ação, Sustentando impacto, Empoderando jovens",
    totalProjects: "Total de Projetos",
    beneficiaries: "Beneficiários",
    volunteerHours: "Horas de Voluntariado",
    localOrganizations: "Organizações Locais",
    countries: "Países",
    projects: "projetos",
    economicRecovery: "Recuperação Econômica",
    workforceReadiness: "Prontidão da Força de Trabalho",
    mentalHealth: "Saúde Mental",
    shareOfRiseProjects: "Participação em Projetos RISE",
    focusAreas: "Áreas de Foco",
    keyInitiatives: "Iniciativas Chave",
    fiiWeight: "Peso FII",
    smeSupport: "Apoio a PMEs, microfinanças, acesso ao mercado",
    skillsTraining: "Treinamento de habilidades, programas de emprego",
    awarenessSupport: "Campanhas de conscientização, serviços de apoio",
    regionalProjectDistribution: "Distribuição Regional de Projetos",
    largestVolume: "Maior Volume",
    rapidGrowth: "Crescimento Rápido",
    consolidating: "Consolidando",
    qualityFocus: "Foco em Qualidade",
    strategicOpportunity: "Oportunidade Estratégica",
    strategicOpportunityText: "América e Europa representam apenas 11% dos projetos mas têm forte infraestrutura para RISE. Considere expansão direcionada.",
    sdgAlignmentMatrix: "Matriz de Alinhamento ODS",
    sdgsAddressed: "12 ODS Abordados",
    riseProjectsAddress: "Projetos RISE abordam 12 dos 17 Objetivos de Desenvolvimento Sustentável da ONU",
    primaryFocusAreas: "Áreas de Foco Primárias",
    allSdgsCoverage: "Cobertura de Todos os ODS",
    primaryFocus: "Foco Primário",
    crossCutting: "Transversal",
    sizeProjectCount: "Contagem de Projetos",
    resourcesMobilized: "Recursos Mobilizados",
    total: "Total",
    totalResourceMobilization: "Mobilização Total de Recursos",
    estimatedValue: "Valor econômico estimado gerado",
    resourceBreakdown: "Detalhamento de Recursos",
    volunteer: "Valor do Voluntariado",
    volunteerHoursValue: "Valor das Horas de Voluntariado",
    corporate: "Parceiros Corporativos",
    corporatePartnerships: "Parcerias Corporativas",
    grantsFoundations: "Doações e Fundações",
    hoursAtStandardRate: "435.605 horas a taxa padrão",
    hoursAtStandardRates: "horas a taxas padrão",
    globalCorporatePar: "Parcerias corporativas globais",
    globalCorporatePartners: "Parceiros corporativos globais",
    foundationSupport: "Apoio de fundações e doações",
    efficiencyMetrics: "Métricas de Eficiência",
    costPerBeneficiary: "Custo por Beneficiário",
    volunteerROI: "ROI do Voluntariado",
    partnerRetention: "Retenção de Parceiros",
    highlyEfficient: "Altamente Eficiente",
    forEveryDollar: "Para cada dólar investido",
    yearOverYear: "Ano a ano",
    virtualEvent: "Evento Virtual",
    globalYouthDialogue: "Diálogo Global da Juventude",
    dialogueDate: "24 de Setembro de 2025",
    theme: "Tema",
    youthLeadershipUncertainty: "Liderança Jovem em Tempos de Incerteza",
    globalYouthLeaders: "Líderes Jovens Globais",
    continents: "Continentes",
    registrants: "Registrados",
    liveAttendees: "Participantes Ao Vivo",
    fbLiveViewers: "Espectadores FB Live",
    totalReach: "Alcance Total",
    comments: "Comentários",
    shares: "Compartilhamentos",
    reactions: "Reações",
    eventOutcomes: "Resultados do Evento",
    leadershipTrainingHours: "Horas de Treinamento de Liderança",
    certificatesIssued: "Certificados Emitidos",
    businessPartnerships: "Parcerias de Negócios",
    mentorshipRelationships: "Relacionamentos de Mentoria",
    riseProjectsCommissioned: "Projetos RISE Comissionados",
    mediaImpressions: "Impressões de Mídia",
    genderDistribution: "Distribuição de Gênero",
    male: "Masculino",
    female: "Feminino",
    nonBinary: "Não-Binário",
    attendanceType: "Tipo de Participação",
    events20242025: "Eventos 2024-2025",
    repeatAttendees: "Participantes Recorrentes",
    firstTime: "Primeira Vez",
    firstTimeRecruitment: "Oportunidade chave de recrutamento!",
    conferencesMap: "Mapa de Conferências",
    areaConferencesWorldCongress: "Conferências de Área e Congresso Mundial",
    events: "Eventos",
    resetView: "Redefinir Visualização",
    worldCongress: "Congresso Mundial",
    areaConference: "Conferência de Área",
    expected: "esperado",
    openInGoogleMaps: "Abrir no Google Maps",
    participants: "participantes",
    teams: "equipes",
    prizeMoney: "Prêmio em Dinheiro",
    largest: "Maior",
    top: "Top",
    impact: "Impacto",
    winnerProfile: "Perfil do Vencedor",
    averageAge: "Idade Média",
    femaleFounders: "Fundadoras Femininas",
    participationByConference: "Participação por Conferência",
    curriculumAreas: "Áreas do Currículo",
    outcomes: "Resultados",
    partnerNetwork: "Rede de Parceiros",
    new: "NOVO",
    learnMore: "Saiba Mais",
    lessDetails: "Menos Detalhes"
  },
  programDetailData: {
    cyeObjective: "Desenvolvendo jovens empreendedores através de competições de inovação",
    cyeImpact1: "108 empreendedores de 20+ países competiram",
    cyeImpact2: "Mais de $10.000 em prêmios concedidos",
    cyeImpact3: "35% dos participantes eram fundadoras femininas",
    cyeImpact4: "40% no setor de tecnologia, diversificando indústrias",
    cyeImpact5: "Conexões de mentoria e networking estabelecidas",
    services: "Serviços",
    other: "Outro",
    cyeGeography: "Distribuição global em todas as 4 áreas JCI",
    cyeFiiAlignment: "Apoia dimensões de recuperação econômica e empreendedorismo do FII",
    jibObjective: "Desenvolvimento profissional e networking de negócios",
    jibCurriculum1: "Inovação e Estratégia de Negócios",
    jibCurriculum2: "Gestão Financeira",
    jibCurriculum3: "Acesso ao Mercado Global",
    jibCurriculum4: "Excelência em Liderança",
    jibCurriculum5: "Saúde Mental nos Negócios",
    jibOutcome1: "Relataram habilidades de negócios melhoradas",
    jibOutcome2: "Expandiram rede profissional",
    jibOutcome3: "Lançaram novas iniciativas de negócios",
    jibOutcome4: "Aumentaram confiança em liderança",
    jibOutcome5: "Aplicaram práticas de bem-estar mental",
    growingRapidly: "Crescendo Rapidamente",
    globalMentors: "Mentores Globais",
    angelInvestors: "Investidores Anjo",
    vcNetworks: "Redes de VC",
    jibFiiAlignment: "Alinha-se com dimensões de força de trabalho e econômicas do FII",
    fiiAlignment: "Alinhamento FII",
    publicSpeakingName: "Competição de Oratória",
    publicSpeakingObjective: "Desenvolve confiança e excelência em comunicação",
    psTopic1: "Juventude e Ação Climática",
    psTopic2: "Liderança na Incerteza",
    psTopic3: "Impacto da Transformação Digital",
    psTopic4: "Construção de Resiliência Comunitária",
    psSkill1: "Comunicação Verbal",
    psSkill2: "Pensamento Crítico",
    psSkill3: "Construção de Confiança",
    psSkill4: "Consciência Intercultural",
    psSkill5: "Presença de Liderança",
    reportIncreasedConfidence: "relatam aumento de confiança",
    equalParticipation: "Participação Igual",
    psFiiAlignment: "Melhora prontidão da força de trabalho através de habilidades de comunicação",
    debatingName: "Campeonato de Debate",
    debatingObjective: "Competição de debate multilíngue promovendo pensamento crítico",
    english: "Inglês",
    french: "Francês",
    spanish: "Espanhol",
    debateSkill1: "Raciocínio Analítico",
    debateSkill2: "Argumentação Estruturada",
    debateSkill3: "Habilidades de Pesquisa",
    debateSkill4: "Consciência Global",
    debateSkill5: "Excelência Acadêmica",
    debateFormat: "Formato de Debate Escolar Mundial",
    debateFiiAlignment: "Desenvolve pensamento crítico para prontidão da força de trabalho",
    debateImpact1: "Pensamento analítico aprimorado",
    debateImpact2: "Oratória melhorada",
    debateImpact3: "Habilidades de metodologia de pesquisa",
    debateImpact4: "Compreensão intercultural"
  },
  sdgs: {
    noPoverty: "Erradicação da Pobreza",
    zeroHunger: "Fome Zero",
    goodHealth: "Boa Saúde e Bem-estar",
    qualityEducation: "Educação de Qualidade",
    genderEquality: "Igualdade de Gênero",
    cleanWater: "Água Limpa e Saneamento",
    affordableEnergy: "Energia Limpa e Acessível",
    decentWork: "Trabalho Decente e Crescimento Econômico",
    industryInnovation: "Indústria, Inovação e Infraestrutura",
    reducedInequalities: "Redução das Desigualdades",
    sustainableCities: "Cidades e Comunidades Sustentáveis",
    responsibleConsumption: "Consumo e Produção Responsáveis",
    climateAction: "Ação Climática",
    lifeBelowWater: "Vida na Água",
    lifeOnLand: "Vida Terrestre",
    peaceJustice: "Paz, Justiça e Instituições Eficazes",
    partnerships: "Parcerias para os Objetivos"
  },
  programsShowcase: { title: "Programas e Eventos Principais", subtitle: "Dados de impacto real do Relatório de Impacto JCI 2025", coreInitiative: "Iniciativa Principal", riseDesc: "Reconstruindo, Inspirando, Sustentando e Empoderando comunidades", projects: "Projetos", beneficiaries: "Beneficiários", volunteerHours: "Horas de Voluntariado", risePillarsDistribution: "Distribuição de Pilares RISE", economicRecovery: "Recuperação Econômica", workforceReadiness: "Prontidão da Força de Trabalho", mentalHealth: "Saúde Mental", cye: "Creative Young Entrepreneur (CYE)", cyeDesc: "Competição regional de empreendedorismo", jib: "JCI in Business (JIB)", jibDesc: "Programa de networking e desenvolvimento de negócios", publicSpeaking: "Competição de Oratória", publicSpeakingDesc: "Desenvolve confiança e habilidades de comunicação", debating: "Campeonato de Debate", debatingDesc: "Competição de debate multilíngue", english: "Inglês", french: "Francês", spanish: "Espanhol", totalParticipants: "Total de Participantes", totalTeams: "Total de Equipes", prize: "Prêmio", teams: "equipes", areaConferences2025: "Conferências de Área 2025", asiaPacificConference: "Conferência Ásia-Pacífico", europeConference: "Conferência Europa", africaMeConference: "Conferência África & ME", americasConference: "Conferência Américas", attendees: "Participantes", firstTimers: "iniciantes", featuredEvent: "Evento em Destaque", globalYouthDialogue: "Diálogo Global da Juventude 2025", registrants: "Registrados", liveAttendees: "Participantes Ao Vivo", fbLiveViewers: "Espectadores FB Live", chatMessages: "Mensagens de Chat", jciSenators: "Senadores JCI", senatorsNew: "84 novos em 2025", toypRecognized: "TOYP Reconhecido", toypCategories: "10 categorias", peopleImpacted: "Pessoas Impactadas", throughAllPrograms: "Através de todos os programas", sourceNote: "Relatório de Impacto JCI 2025 - Dados oficiais de programas e eventos" },
  sdgAlignment: { title: "Alinhamento ODS", subtitle: "Programas JCI mapeados para Objetivos de Desenvolvimento Sustentável da ONU", sdgCount: "ODS Cobertas", sdgCountDesc: "Programas JCI contribuem para 12 dos 17 ODS da ONU", primaryGoals: "Objetivos Principais", primaryGoalsDesc: "Mais impactados pelas iniciativas JCI", goodHealth: "Boa Saúde e Bem-estar", qualityEducation: "Educação de Qualidade", decentWork: "Trabalho Decente e Crescimento Econômico", reducedInequalities: "Desigualdades Reduzidas", partnerships: "Parcerias para os Objetivos", impactMapping: "Mapeamento de Impacto", riseProjects: "Projetos RISE", riseProjectsDesc: "Alinhado com saúde mental, força de trabalho e recuperação econômica", cyeProgram: "Programa CYE", cyeDesc: "Apoia empreendedorismo e inovação", jibProgram: "Programa JIB", jibDesc: "Promove habilidades de negócios e redes profissionais", toyp: "TOYP", toypDesc: "Reconhece liderança e impacto jovem", sourceNote: "Fonte: Relatório de Impacto JCI 2025 - Metodologia de alinhamento ODS" },
  impactMetricsTitle: "Métricas de Impacto",
  impactMetricsSubtitle: "Medindo o alcance global da JCI e impacto comunitário",
  riseTitle: "Iniciativa RISE",
  riseSubtitle: "Reconstruindo, Inspirando, Sustentando e Empoderando comunidades",
  cyeTitle: "Creative Young Entrepreneurs (CYE)",
  cyeSubtitle: "Competição regional de empreendedorismo",
  jibTitle: "JCI in Business (JIB)",
  jibSubtitle: "Networking de negócios e desenvolvimento profissional",
  debatingTitle: "Campeonato de Debate",
  debatingSubtitle: "Competição de debate multilíngue promovendo pensamento crítico",
  publicSpeakingTitle: "Competição de Oratória",
  publicSpeakingSubtitle: "Desenvolvendo confiança e habilidades de comunicação",
  conferencesTitle: "Conferências de Área",
  conferencesSubtitle: "Encontros regionais anuais para networking e treinamento",
  rise: { title: "Iniciativa JCI RISE", subtitle: "Reconstruindo, Inspirando, Sustentando e Empoderando comunidades", totalProjects: "Total de Projetos RISE", beneficiariesReached: "Beneficiários Alcançados", volunteerHours: "Horas de Voluntariado", budgetMobilized: "Orçamento Mobilizado", pillarDistribution: "Distribuição de Pilares", mentalHealth: "Saúde Mental", workforceReadiness: "Prontidão da Força de Trabalho", economicRecovery: "Recuperação Econômica", regionalBreakdown: "Detalhamento Regional", projectsByRegion: "Projetos por Região", topProjects: "Principais Projetos RISE por Impacto", viewFullReport: "Ver Relatório RISE Completo" },
  cye: { title: "Creative Young Entrepreneurs (CYE)", subtitle: "Competição regional de empreendedorismo promovendo inovação", participants: "Total de Participantes", teams: "Total de Equipes", prizePool: "Pool Total de Prêmios", winnersTitle: "Vencedores 2024", categories: "Categorias de Competição", socialEnterprise: "Empresa Social", techInnovation: "Tecnologia e Inovação", greenBusiness: "Negócio Verde", traditionalBusiness: "Negócio Tradicional", impactMetrics: "Métricas de Impacto", businessesLaunched: "Negócios Lançados", jobsCreated: "Empregos Criados", fundingSecured: "Financiamento Garantido" },
  jib: { title: "JCI in Business (JIB)", subtitle: "Desenvolvimento profissional e programa de networking de negócios", activeMembers: "Membros JIB Ativos", networkingEvents: "Eventos de Networking", businessPartnerships: "Parcerias de Negócios", benefits: "Benefícios JIB", professionalNetwork: "Acesso a rede profissional", businessSkills: "Desenvolvimento de habilidades de negócios", mentorship: "Oportunidades de mentoria", careerAdvancement: "Apoio ao avanço de carreira", focusAreas: "Áreas de Foco", leadership: "Desenvolvimento de Liderança", networking: "Networking de Negócios", skills: "Habilidades Profissionais", entrepreneurship: "Apoio ao Empreendedorismo" },
  debating: { title: "Campeonato de Debate JCI", subtitle: "Competição de debate multilíngue promovendo pensamento crítico", totalTeams: "Total de Equipes", languages: "Idiomas", countries: "Países Participantes", format: "Formato de Competição", preliminaryRounds: "Rodadas Preliminares", semifinals: "Semifinais", grandFinal: "Grande Final", skillsDeveloped: "Habilidades Desenvolvidas", criticalThinking: "Pensamento Crítico", publicSpeaking: "Oratória", research: "Pesquisa e Análise", teamwork: "Trabalho em Equipe e Colaboração", recentChampions: "Campeões Recentes", viewHighlights: "Ver Destaques do Debate" },
  publicSpeaking: { title: "Competição de Oratória", subtitle: "Construindo confiança e excelência em comunicação", participants: "Total de Participantes", countries: "Países Participantes", speechTopics: "Tópicos de Discurso", improvisation: "Discurso Improvisado", prepared: "Discurso Preparado", persuasive: "Discurso Persuasivo", competencies: "Competências Avaliadas", delivery: "Entrega e Presença", content: "Conteúdo e Estrutura", impact: "Impacto e Persuasão", languageProficiency: "Proficiência em Idioma", recentWinners: "Vencedores Recentes", watchSpeeches: "Assistir Discursos Vencedores" },
  conferences: { title: "Conferências de Área JCI", subtitle: "Encontros regionais anuais para networking, treinamento e liderança", totalAttendees: "Total de Participantes (2025)", conferences: "Conferências", firstTimers: "Participantes Iniciantes", countries: "Países Representados", conferenceHighlights: "Destaques da Conferência", keynotes: "Palestrantes Principais", workshops: "Workshops de Treinamento", networking: "Sessões de Networking", awards: "Prêmios e Reconhecimento", upcomingConferences: "Próximas Conferências 2025", registerNow: "Registre-se Agora", viewSchedule: "Ver Cronograma" },
  toyp: { title: "Ten Outstanding Young Persons (TOYP)", subtitle: "Reconhecendo líderes jovens excepcionais mundialmente", recognizedLeaders: "Líderes Reconhecidos (2025)", categories: "Categorias de Prêmio", nominationsOpen: "Período de Nomeações", categoryList: { businessEconomic: "Conquista Empresarial e Econômica", humanitarian: "Serviço Humanitário e Voluntário", science: "Liderança e Conquista Acadêmica", political: "Assuntos Políticos, Legais e Governamentais", cultural: "Conquista Cultural", medical: "Inovação Médica", environmental: "Liderança Ambiental", world: "Paz Mundial e Direitos Humanos", children: "Bem-estar e Educação Infantil", personal: "Melhoria e Conquista Pessoal" }, selectionProcess: "Processo de Seleção", nomination: "Nomeação", evaluation: "Avaliação", recognition: "Reconhecimento", pastHonorées: "Homenageados TOYP Anteriores", submitNomination: "Enviar Nomeação" },
  programMetrics: { title: "Métricas de Participação em Programas", subtitle: "Engajamento de membros em programas JCI", totalParticipants: "Total de Participantes do Programa", programReach: "Alcance do Programa por Região", growthTrend: "Crescimento Ano a Ano", satisfactionScore: "Satisfação do Participante", highRating: "Classificação Alta", repeatParticipation: "Participação Repetida", likelyToRecommend: "Provável de recomendar", topPerformingPrograms: "Principais Programas de Desempenho", program: "Programa", participants: "Participantes", satisfaction: "Satisfação", growth: "Crescimento" },
  programImpact: { title: "Avaliação de Impacto do Programa", subtitle: "Medindo resultados e impacto de longo prazo", skillsDevelopment: "Desenvolvimento de Habilidades", reportImprovedSkills: "Relatam habilidades de liderança melhoradas", networkGrowth: "Crescimento da Rede", expandedNetwork: "Expandiram rede profissional", careerAdvancement: "Avanço de Carreira", careerProgress: "Atribuem progresso de carreira à JCI", communityImpact: "Impacto Comunitário", ledCommunityProjects: "Lideraram ou participaram de projetos comunitários", impactStories: "Histórias de Impacto", readStories: "Ler Histórias de Membros", shareYourStory: "Compartilhe Sua História" },
  humanDuties: {
    title: "Iniciativa Internacional de Deveres Humanos",
    headline: "67.101 Vozes Globais pela Liderança Ética",
    heroDescription: "A Iniciativa Internacional de Deveres Humanos representa uma mudança fundamental no discurso global de liderança. Enquanto os direitos humanos são amplamente reconhecidos, o conceito complementar de deveres humanos—as responsabilidades que acompanham os direitos—permanece pouco explorado. A JCI lidera esta conversa através da Declaração Universal de Deveres Humanos para Líderes.",
    totalPetitions: "Total de Petições Assinadas",
    globalSignatories: "signatários globais",
    geographicCoverage: "Cobertura Geográfica",
    countriesAcross: "países em 4 regiões",
    nationalAmbassadors: "Embaixadores Nacionais",
    leadingCoordination: "liderando coordenação IHDD",
    regionalBreakdown: "Detalhamento Regional",
    region: "Região",
    petitionsSigned: "Petições Assinadas",
    percentGlobal: "% do Global",
    asiaPacific: "Ásia e o Pacífico",
    africaMiddleEast: "África e Oriente Médio",
    americas: "América",
    europe: "Europa",
    highMomentum: "Alto momentum",
    growingActivities: "Crescendo (19 atividades)",
    establishedBase: "Base estabelecida",
    emerging: "Emergente",
    keyMilestones: "Marcos Institucionais Chave",
    nelsonMandelaEndorsement: "Endosso da Fundação Nelson Mandela",
    mandelaDesc: "Reconhecimento oficial da Iniciativa de Deveres Humanos (2025)",
    legislativeSuccess: "Sucesso Legislativo",
    legislativeDesc: "Estado de Zulia (Venezuela) aprovou Lei de Deveres Humanos, declarou 10 de julho como Dia Internacional dos Deveres Humanos (2025)",
    ihddImpact: "Impacto do Dia Internacional dos Deveres Humanos (IHDD)",
    reportedActivities: "Atividades Reportadas 2025",
    activitiesAcrossRegions: "iniciativas oficialmente documentadas em regiões",
    sevenDutiesFramework: "Os 7 Deveres para Líderes",
    duty1: "Dever de Defender a Dignidade Humana",
    duty2: "Dever de Servir o Bem Comum",
    duty3: "Dever de Proteger o Meio Ambiente",
    duty4: "Dever de Promover Equidade e Justiça",
    duty5: "Dever de Fomentar Paz e Entendimento",
    duty6: "Dever de Apoiar Educação e Desenvolvimento",
    duty7: "Dever de Agir com Integridade e Responsabilidade",
    ctaTitle: "Faça Parte do Movimento",
    signPetition: "Assine a Petição",
    becomeAmbassador: "Torne-se um Embaixador Nacional",
    viewStories: "Ver Histórias IHDD",
    sourceNote: "Fonte: Relatório de Impacto JCI 2025 – Dados da Iniciativa de Deveres Humanos"
  },
  strategicPartnerships: {
    title: "Parcerias Estratégicas Globais",
    headline: "Construindo Pontes: Parcerias Estratégicas Globais da JCI",
    heroDescription: "O impacto da JCI é amplificado através de parcerias estratégicas com organizações globais que compartilham nosso compromisso de desenvolver jovens líderes e promover o desenvolvimento sustentável.",
    activePartnership: "Parceria ativa",
    growingPartnership: "Parceria em crescimento",
    emergingPartnership: "Parceria emergente",
    infrastructurePartner: "Parceiro de infraestrutura",
    partnershipTiers: "Níveis de Parceria",
    tier1Active: "Nível 1: Parcerias Ativas",
    tier1Desc: "Continuar colaboração, expandir mentoria",
    tier2Growing: "Nível 2: Parcerias em Crescimento",
    tier2Desc: "Roteiro de 6 meses para integração mais profunda",
    tier3Emerging: "Nível 3: Parcerias Emergentes",
    tier3Desc: "Estratégico para crescimento organizacional",
    tier4Infrastructure: "Nível 4: Parceiros de Infraestrutura",
    tier4Desc: "Eficiência operacional e capacitação digital",
    roiIndicators: "Indicadores de ROI de Parceria",
    partner: "Parceiro",
    memberBenefit: "Benefício para Membros",
    orgBenefit: "Benefício Organizacional",
    effortLevel: "Nível de Esforço",
    roiTimeline: "Cronograma de ROI",
    low: "Baixo",
    medium: "Médio",
    veryLow: "Muito Baixo",
    immediate: "Imediato",
    threeMonths: "3 meses",
    sixMonths: "6 meses",
    oneYear: "1 ano",
    iccName: "Câmara de Comércio Internacional (ICC)",
    unName: "Nações Unidas (ONU)",
    unescoName: "UNESCO",
    worldBankName: "Banco Mundial / IFC",
    wefName: "Fórum Econômico Mundial (WEF)",
    aiesecName: "AIESEC",
    bniName: "BNI (Business Network International)",
    wbafName: "Fórum de Aliança de Mulheres de Negócios (WBAF)",
    zohoName: "Zoho",
    gyefName: "Fórum Econômico Global da Juventude (GYEF)",
    ctaTitle: "Junte-se à Rede de Parcerias",
    viewAllPartnerships: "Ver Todas as Parcerias",
    partnerWithJCI: "Parceria com JCI",
    accessResources: "Acessar Recursos de Parceiros",
    sourceNote: "Fonte: Relatório de Impacto JCI 2025 – Parcerias Estratégicas"
  }
} as const;
